<div class="container-fluid">
  @if (isLoading) {
<div class="row flex-row justify-content-center">
    <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>

  </div>
}
  @if (!isLoading) {
<div class="row table-container">
    @if (!ignore && !showBulkMessage) {
<table mat-table [dataSource]="data" matSort class="review-diagnostics-mat-table">
      @for (col of columns; track col.data) {
        @if (col.data != null && col.visible) {
          <ng-container [matColumnDef]="col.data">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="{width: col.width || 'inherit'}">
              {{ col.title }}
            </th>
            <td mat-cell *matCellDef="let rowData">
              @if ((rowData[col.data] === 'Critical') || (rowData[col.data] === 'Informational')) {
<span class="Appkit4-icon"
                [ngClass]="{'icon-alert-fill': rowData[col.data] === 'Critical',
                             'icon-information-fill': rowData[col.data] === 'Informational'}"
                [ngStyle]="{'color': rowData[col.data] === 'Critical' ? '#D04A02' : '#212121',
                            'margin-right':'10px'}">
              </span>
}
              @if (col.data == 'FAILCNT') {
<span [ngStyle]="{'color':(rowData[col.data] > 0 && rowData.DIAG_MSG == 'Critical') ? '#D04A02' : '#212121'}">
                {{ rowData[col.data] }}
              </span>
}
              @if (col.data != 'FAILCNT') {
<span [ngStyle]="{'color': rowData[col.data] > 0 ? 'red' : 'black'}">
                {{ rowData[col.data] }}
              </span>
}
            </td>
          </ng-container>
        }
      }

      <tr mat-header-row *matHeaderRowDef="visibleColumnFields"></tr>
      <tr mat-row *matRowDef="let row; columns: visibleColumnFields"></tr>
    </table>
}

    @if (ignore) {
<strong class="w-100 text-center">Please make sure all the diagnostics are cleared before this submission is filed to IRS.</strong>
}
  </div>
}

  <div class="row flex-row justify-content-end ap-mt-spacing-3">
    @if (hasDiagnostics && !ignore) {
<ap-button [btnType]="'primary'" class="ap-mr-spacing-3" [label]="'Ignore Diagnostics'" (onClick)="doIgnore()">
    </ap-button>
}
    @if (!hasDiagnostics || ignore) {
<ap-button [btnType]="'primary'" [label]="'Ok'" (onClick)="cancel()">
    </ap-button>
}
  </div>
</div>
